import { SingleValueCookie } from 'saddlebag-cookie';

const X_GATEWAY_SERVED_BY = 'X-Gateway-Servedby';

const storeXGatewayServedBy = (xGatewayServedBy: any) => {
  if (!xGatewayServedBy || xGatewayServedBy === 'undefined') {
    return;
  }
  const cookie = new SingleValueCookie(X_GATEWAY_SERVED_BY);
  cookie.setValue(xGatewayServedBy);
  cookie.store(1, { path: '/' });
};

const getXGatewayServedBy = () => {
  const cookie = new SingleValueCookie(X_GATEWAY_SERVED_BY);
  return cookie.getValue();
};

export { X_GATEWAY_SERVED_BY, getXGatewayServedBy, storeXGatewayServedBy };
